import React from 'react'
import styles from "./DetailsCard.module.scss"
function DetailsCard({ title, children, titleColor = false }) {
    return (
        <div className={`${styles.topCont} `}>
            <div className={!titleColor ? styles.title : styles.title2}>{title}</div>
            {children}
        </div>
    )
}

export default DetailsCard
